import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时更新平台最新片源上线、系统升级与专题策划动态
          </p>
        </div>
        <div className="relative border-l-2 border-background-300 ml-4 md:ml-6">
          {updatesData.map((item, index) => (
            <div key={item.id} className="mb-8 last:mb-0 pl-8 md:pl-10 relative">
              <div className="absolute left-0 top-1 w-3 h-3 rounded-full bg-accent-500 -translate-x-[7px] ring-4 ring-background-100"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 mb-1.5">
                <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                <span className="hidden sm:block text-foreground-300 mx-1">·</span>
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap w-fit ${
                  item.tag === '新片上线' ? 'bg-accent-100 text-accent-700' :
                  item.tag === '系统公告' ? 'bg-secondary-100 text-secondary-700' :
                  item.tag === '专题策划' ? 'bg-primary-100 text-primary-700' :
                  'bg-background-200 text-foreground-600'
                }`}>
                  {item.tag}
                </span>
              </div>
              <a href={item.link} className="text-sm md:text-base text-foreground-800 hover:text-accent-600 transition-colors leading-relaxed cursor-pointer font-medium">
                {item.title}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}